// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_GetTemplatesByFranquiasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/whatsapp_message_templates/get_templates_by_franquias.
 *
 * Returns the union (unique) of WhatsApp templates linked to the requested
 * franquia_ids. Used by the messaging inbox composable to populate the
 * "saved messages" picker per device.
 */
import type { WhatsappMessageTemplates_TemplateRow } from './WhatsappMessageTemplates_TemplateRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface WhatsappMessageTemplates_GetTemplatesByFranquiasResponseDados {
templates: WhatsappMessageTemplates_TemplateRow[]
}

export type WhatsappMessageTemplates_GetTemplatesByFranquiasResponse = ApiResponse<WhatsappMessageTemplates_GetTemplatesByFranquiasResponseDados>;

registerResponseContract('WhatsappMessageTemplates_GetTemplatesByFranquiasResponse', {
  templates: {
    type: 'array',
    required: true,
    items: {
      template_id:        { type: 'number',  required: true },
      template_name:      { type: 'string',  required: true },
      template_content:   { type: 'string',  required: true },
      template_type:      { type: 'string',  required: true },
      template_media_url: { type: 'string',  required: false },
      is_active:          { type: 'number',  required: true },
      franquias_nomes:    { type: 'string',  required: false },
      created_at:         { type: 'string',  required: true },
      updated_at:         { type: 'string',  required: true },
    },
  },
})
